import {Component} from '@angular/core';
import {AppComponent} from './app.component';
import {TenantDto} from "../../../../features/auth/tenant/tenant.dto";
import {
    UiUserThemeConfigurations
} from "../../../../features/core/ui/component/protected-components/ui-setting-user/data/ui-user-theme-configurations";
import {TenantService} from "../../../../features/auth/tenant/tenant.service";
import {AppMainComponent} from "./app.main.component";
import {UiSettingUserService} from "../../../../features/core/ui/service/api/ui-setting-user.service";
import {MvsMessageService} from "../../../../features/core/shared/service/message/mvs-message.service";
import {MvsObjectNavigationService} from "../../../../features/core/shared/navigation/mvs-object-navigation.service";

@Component({
    selector: 'app-rightmenu',
    templateUrl: './app.rightmenu.component.html',
    standalone: false
})
export class AppRightMenuComponent {

    showUserSettingDialog: boolean = false;
    tenantInfo: TenantDto | null = null;
    uiUserSettingsDto: UiUserThemeConfigurations;
    busy: boolean = false;

    constructor(protected tenantService: TenantService,
                public appMain: AppMainComponent,
                public app: AppComponent,
                protected uiSettingUserService: UiSettingUserService,
                protected messageService: MvsMessageService,
                protected navigationService: MvsObjectNavigationService
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.tenantInfo = this.tenantService.getTenantInfo();
    }

    copyToClipboard(text: string): void {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    copyRouteToClipboard() {
        const fullRoute = window.location.href;

        // Call the copyToClipboard method to copy the route to the clipboard
        this.copyToClipboard(fullRoute);
    }

    openUserSettingDialog() {
        this.appMain.rightMenuActive = false;
        this.showUserSettingDialog = true;
    }

    navigateToGoodToKnow() {
        const url = '/cc/goodToKnow';
        this.navigationService.handlePageNavigation(url)
    }

    handleSaveUserSettingClick() {
        const json = JSON.stringify(this.uiUserSettingsDto);

        this.uiSettingUserService.me(json).subscribe(res => {
            this.messageService.showSuccessMessage('', 'User Settings saved');
            localStorage.setItem('ui.userSettings', JSON.stringify(res));
            this.busy = false;
        }, error => {
            this.busy = false;
        });
    }

    handleCloseUserSettingDialog() {
        this.showUserSettingDialog = false;
    }

    handleUserSettingsChange(event: UiUserThemeConfigurations) {
        this.uiUserSettingsDto = event;
    }
}
